<app-header></app-header>

<div style ="background:#26abe3" class="header-search-bar">
    <div class="container">
        <div class="header-search-bar-main">
            <form #searchDoctor="ngForm" (ngSubmit)="searchDoctorForm(searchDoctor)">
                <div class="row">
                    <div class="col-md-6 col-lg-3">
                            <div class="ng-autocomplete1 form-group-img">
                                    <ng-autocomplete 
                                      [data]="cities"
                                      placeHolder ="Select City Name"
                                      [initialValue] ="object.city"
                                      [searchKeyword]="object.city"
                                      (selected)='selectEvent($event,searchDoctor)'
                                      (inputChanged)='onChangeSearch($event)'
                                      (inputFocused)='onFocused($event)'
                                      [itemTemplate]="itemTemplate"
                                      [notFoundTemplate]="notFoundTemplate"
                                      name="city" [(ngModel)]="object.city"
                                      >                                 
                                    </ng-autocomplete>
                                     
                                    <ng-template #itemTemplate let-item>
                                    <a [innerHTML]="item"></a>
                                    </ng-template>
                                     
                                    <ng-template #notFoundTemplate let-notFound>
                                    <div [innerHTML]="notFound"></div>
                                    </ng-template>

                                    <span class="c-omni-searchbox__button-container">
                                        <span class="c-omni-searchbox__button c-omni-searchbox__button" data-qa-id="current_location">
                                            <i class="fa fa-map-marker" aria-hidden="true"></i>
                                          <span (click)="detectLocation(searchDoctor)" *ngIf="searchDoctor.value.city!=currentCity" class="c-omni-searchbox__button__text">
                                            Detect </span>
                                          </span>
                                        </span>
                                    </div>

                        <!-- <div class="form-group-img">
                            <select (change)="searchDoctorForm(searchDoctor)" [(ngModel)]="object.city"  name="city" class="form-control">
                              <option value=''>Choose City...</option>
                                <option [hidden]="city==''" *ngFor="let city of cities" [value]="city">{{ city }}</option>
                                              
                              
                            </select>
                            <i class="fa fa-map-marker" aria-hidden="true"></i>
                        </div> -->
                    </div>
                    <div class="col-md-6  col-lg-4">
                        <div class="form-group-img">
                            <input  [(ngModel)]="object.name" name="name" type="text" class="form-control"   placeholder="Search hospital by name..">
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-5">
                        <div class="form-group-btn">
                            <input  name="treatment" [(ngModel)]="object.treatment" type="text" class="form-control" placeholder="Search hospital by Treatment (Optional)">
                            <input type="submit" class="btn-style" value="Search">
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<!-- </header> -->

<section class="hospitals padd-row">
  <div class="container">
      <div class="hosptials-main">
          <div class="row">
              <div *ngFor="let hospital of hospitalList" class="col-md-6 col-lg-4">
                  <div class="hospitals-box card">
                      <div class="hospitals-box-img">
                          <img [src]="hospital.coverPhoto" alt="image">
                          <div class="offer-sticker" *ngIf="hospital.discount!=0"> {{ hospital.discount }}% off </div>
                      </div>
                      <div class="hospitals-box-cnt">
                          <div class="hospitals-box-cnt-heading">
                              <div class="d-md-flex">
                                  <div class="hos-box-cnt-heding-lft">
                                      <h4> {{ hospital.name.slice(0,20) }}  {{ hospital.name.length>20 ? '...' : '' }}  </h4>
                                      <p> {{ hospital.address.slice(0,30) }}  {{ hospital.address.length>30 ? '...' : '' }} </p>
                                  </div>
                                  <div class="doctor-box-rating">
                                      <i class="fa fa-star" aria-hidden="true"></i> <span> {{ !hospital.averageRatings ? 0 : hospital.averageRatings }}/5   </span>
                                      <p>{{ !hospital.review.length ? 0 : hospital.review.length }} Reviews</p>
                                      
                                  </div>
                              </div>                                     
                          </div>
                          <div class="hos-box-btm-cnt">
                              <p class="hos-box-bmt-info">
                                  <span>  {{ hospital.distance/1000 | number:'1.0-0'  }} km Away | Registered Hospital<img width="30px" height="30px" src="assets/images/bluetick.png"> </span>
                                  <!-- <span class="hos-box-cnt-box-info-imgs"> 
                                      <img *ngFor="let doctorimage of hospital.docProfilePic" [src]="doctorimage" alt="image">
                                      <img src="assets/images/doc-img-2.jpg" alt="image">
                                      <img src="assets/images/doc-img-3.jpg" alt="image"> 
                                       <img src="assets/images/twenty-plus-img.jpg" alt="image">
                                  </span> -->
                              </p>
                              <!-- <ul>
                                  <li *ngFor="let single of hospital.treatments"> {{ single }} </li>
                                   <li> Crowns Fixing </li>
                                  <li> Endosurgery </li>
                                  <li> Conservative Density </li> 
                              </ul> -->
                              <div class="hos-box-btns">
                                  <a [routerLink]="['/hospitals/detail/'+hospital._id]" class="btn-style"> More Details </a>
                              </div>
                          </div>
                      </div>

                  </div>
              </div>
             
          </div>

      </div>
      <!-- <div class="doctors-pagination text-center">
          <ul>
              <li> Previous </li>
              <li class="current-pagi"> 1 </li>
              <li> <a href="javascript://"> 2 </a> </li>
              <li> <a href="javascript://"> 3 </a> </li>
              <li> <a href="javascript://"> 4 </a> </li>
              <li> <a href="javascript://" class="next"> Next </a> </li>
          </ul>
      </div> -->
  </div>
  
</section>

<ngx-spinner></ngx-spinner>